<template>
  <div class="container">
    <p>通过对接学校使用的官方文献传递系统可获取资源，点击文献传递按钮。</p>
    <img src="../../assets/images/newhelp/help11.png" alt="" />
    <img src="../../assets/images/newhelp/help12.png" alt="" />
    <p>
      点击文献传递成功后，点击右上角个人信息，进入个人中心后展开个人信息左侧点击我的申请，选择我的文献传递或者我的单篇采选，查看获取的文章全文。
    </p>
    <img src="../../assets/images/newhelp/help13.png" alt="" />
    <img src="../../assets/images/newhelp/help14.png" alt="" />
    <img src="../../assets/images/newhelp/help15.png" alt="" />
    <img src="../../assets/images/newhelp/help16.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
